import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useState } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../../config/config";
import { Box, useTheme } from "@material-ui/core";
import { AddressFormWrapper } from "./components/AddressFormWrapper";
import { AddressFormSubmitter } from "./components/AddressFormSubmitter";
import { AddressForm } from "./components/AddressForm";
import IconTitle from "../../../../../../shared/components/IconTitle";
import Text from "../../../../../../shared/components/Text";

export const AutocompleteAdditionalDataAddress = ({ onSubmitForm, data }) => {
  const { palette } = useTheme();
  const [edit, setEdit] = useState(false);

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_LOCATION}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ADDITIONAL_INFORMATION" />}
          subtitle={<Text tId="CURRENT_RESIDENCE_ADDRESS" />}
        />
      </Box>
      <AddressFormWrapper data={data}>
        <AddressForm edit={edit} setEdit={setEdit} />
        <AddressFormSubmitter
          onSubmitForm={onSubmitForm}
          edit={edit}
          setEdit={setEdit}
        />
      </AddressFormWrapper>
    </>
  );
};
